// API endpoints
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://client-guerdonkicks-backend.vercel.app';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'https://chat.guerdonkicks.com';
export const POPUP_API_URL = process.env.REACT_APP_POPUP_API_URL || 'https://client-guerdonkicks-popupbackend.vercel.app/api/v1/personal-shopper/backend-generate-popup-response/';

// Logo configuration
export const LOGO_URL = process.env.REACT_APP_LOGO_URL || `${FRONTEND_URL}/logo.png`;